import { render } from "./HealthConsultation.vue?vue&type=template&id=12f7d8e5&scoped=true"
import script from "./HealthConsultation.vue?vue&type=script&lang=js"
export * from "./HealthConsultation.vue?vue&type=script&lang=js"

import "./HealthConsultation.vue?vue&type=style&index=0&id=12f7d8e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f7d8e5"]])

export default __exports__